<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ $t("lang.alarm.page_title_line_1") }}
      </h2>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.alarm.box_label_1')"
            :value="number_of_alarm"
            font-size="xs"
            valueColor="red"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="1" v-else />
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <bx-box
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table :data="data" :columns="columns" v-if="!shouldLoading">
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">{{
                    props.row.location_description
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">
                    {{ props.row.description }}
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.gtin
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/minstock/${props.row.gtin}/edit`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.minimum_stock }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">{{
                    formatDate(props.row.date)
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">{{
                    props.row.current_stock
                  }}</bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Alarm",
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      number_of_alarm: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    async getData() {
      try {
        let tempData = await this.$api.alarm.getStockEv();
        for (let i = 0; i < tempData.length; i++) {
          let areaData = await this.$api.area.get(tempData[i].area);
          tempData[i]["location_description"] = areaData.location_description;
          tempData[i]["description"] = areaData.description;
        }
        this.data = tempData;
        this.number_of_alarm = tempData.length;
      } catch (error) {
        console.error(error);
      } finally {
        this.columns = [
          {
            field: "area",
            label: this.$t("lang.alarm.location"),
            centered: true
          },
          {
            field: "location",
            label: this.$t("lang.alarm.area"),
            centered: true
          },
          {
            field: "gtin",
            label: this.$t("lang.alarm.gtin"),
            centered: true
          },
          {
            field: "minimum_stock",
            label: this.$t("lang.alarm.minimum_stock"),
            centered: true
          },
          {
            field: "date",
            label: this.$t("lang.alarm.date"),
            centered: true
          },
          {
            field: "current_stock",
            label: this.$t("lang.alarm.current_stock"),
            centered: true
          }
        ];
        this.shouldLoading = false;
      }
    }
  }
};
</script>
